<template>
  <el-form
    ref="form"
    :model="form"
    :rules="rules"
    size="medium"
    class="card-form"
    label-position="top"
  >
    <el-row
      type="flex"
      align="start"
      class="flex-wrap"
      :gutter="12"
    >
      <el-col
        v-for="field in fields"
        :key="field.key"
        :lg="field.form_width"
      >
        <FormItem
          :form="form"
          :field="field"
          :disabled="disabled"
          :size="'medium'"
        />
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import constants from "@/config/constants";
import FormItem from "@/components/items/FormItem.vue";

export default {
  name: "CardForm",
  components: {
    FormItem,
  },
  props: {
    form: Object,
    fields: Array,
    disabled: Boolean,
  },
  data() {
    return {
      callingAPI: false,
      fileType: constants.FIELD_TYPE,
    };
  },
  computed: {
    rules() {
      const result = {};
      for (let i = 0; i < this.fields.length; i++) {
        const field = this.fields[i];
        const itemRules = [];
        if (field.form.required) {
          itemRules.push({
            required: true,
            message: `${field.name} là trường bắt buộc.`,
            trigger: ["blur", "change"],
          });
        }
        if (field.form.pattern) {
          const dataType = constants.DATA_TYPES.find(
            (t) => t.key === field.form.pattern
          );
          if (dataType) {
            itemRules.push({
              pattern: dataType.pattern,
              message: `${field.name} không hợp lệ.`,
              trigger: ["blur", "change"],
            });
          }
        }
        if (itemRules.length > 0) {
          result[field.key] = itemRules;
        }
      }
      return result;
    },
  },
  methods: {
  },
};
</script>

<style lang="scss">
.card-form {
  .el-form-item__label {
    padding: 0 !important;
    font-size: 16px !important;
    color: black !important;
  }
  .el-checkbox {
    .el-checkbox__inner {
      &::after {
        border-color: #606266 !important;
      }
    }
    .el-checkbox__label {
      color: #606266 !important;
    }
  }
}
</style>
